import Swiper from "swiper";

export function initslideSpecialEvents() {
    const containers = document.querySelectorAll('.js-slide-special-events');
    if (!containers.length) return;

    const swiperInstances = new Map();

    // Reduced motion must not disable the slider: without Swiper the cards
    // cannot be scrolled at all. Only drop the slide animation instead.
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiperConfig = {
        slidesPerView: 'auto',
        speed: reducedMotion ? 0 : 300,
        spaceBetween: 32,
        breakpoints: {
            768: {
                spaceBetween: 56,
            }
        }
    };

    const update = () => {
        containers.forEach(container => {
            const wrapper = container.querySelector('.swiper-wrapper');
            if (!wrapper) return;

            const needsSwiper = wrapper.scrollWidth > container.offsetWidth;
            const instance = swiperInstances.get(container);

            if (needsSwiper && !instance) {
                swiperInstances.set(container, new Swiper(container, swiperConfig));
            } else if (!needsSwiper && instance) {
                instance.destroy(true, true);
                swiperInstances.delete(container);
            }
        });
    };

    update();

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 200);
    });
}
